import React, { memo } from 'react'
import { Box, Card, Divider } from '@mui/material'

import { formatTicks } from '../../util/string.helpers'
import Button from '../shared/button/Button'
import RedeemImage from '../shared/redeem/RedeemImage'
import RedeemProgress from './RedeemProgress'

const RedeemOption = ({
  t,
  currentUserPoints,
  redeemOption: { value, metadata, name, isNft },
  onClick,
  tokenSymbol
}) => {
  const formattedValue = formatTicks(value)
  const renderFooter = () => (
    <Box
      sx={{
        px: 2,
        py: 2.5,
        gap: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Box component='span' sx={{ typography: 'h6' }}>
        {`${formattedValue} ${tokenSymbol}`}
      </Box>

      <Button
        variant='contained'
        label={t('shop.view-item')}
        onClick={onClick}
      />
    </Box>
  )

  return (
    <Card sx={{ width: 1 }}>
      <RedeemImage
        image={metadata?.coverImage}
        metadata={metadata}
        name={name}
        isNft={isNft}
        onClick={onClick}
      />
      <Box sx={{ px: 2, py: 2.5 }}>
        <RedeemProgress
          currentUserPoints={currentUserPoints}
          value={value}
          name={name}
          isNft={isNft}
          tokenSymbol={tokenSymbol}
        />
      </Box>
      <Divider sx={{ borderStyle: 'dashed' }} />
      {renderFooter()}
    </Card>
  )
}

export default memo(RedeemOption)
